import { render, staticRenderFns } from "./page04.vue?vue&type=template&id=3b48a1be&scoped=true&"
import script from "./page04.vue?vue&type=script&lang=js&"
export * from "./page04.vue?vue&type=script&lang=js&"
import style0 from "./page04.vue?vue&type=style&index=0&id=3b48a1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48a1be",
  null
  
)

export default component.exports